"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));
var _ThemeWrapper = require("./ThemeWrapper.utils");
var _theming = require("../theming.types");
var _logService = require("../../tools/service/log/logService");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var runPropValidation = function runPropValidation(name) {
  if (!Object.values(_theming.Theme).includes(name)) {
    (0, _logService.logSpecificErrorMessage)('THEME_WRAPPER', "\n \"".concat(name, "\" is not a valid theme name. The \"default\" name is applied as fallback.        \n You should import the name from \"import { Theme } from '@quintoandar/cozy-core/theming';\""));
  }
};
var ThemeWrapper = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
    children = _ref.children;
  runPropValidation(name);
  return /*#__PURE__*/_react["default"].createElement(_ThemeProvider["default"], {
    name: name
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _ThemeWrapper.mountThemeClassName)(name),
    ref: ref
  }, children));
});
ThemeWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes["default"].oneOf(Object.values(_theming.Theme)),
  children: _propTypes["default"].node
} : {};
ThemeWrapper.defaultProps = {
  name: _theming.Theme.DEFAULT
};
var _default = exports["default"] = ThemeWrapper;